module.exports = require("core-js/modules/es.parse-int.js");